import { ThumbsUpDownOutlineIcon } from './ThumbsUpDownOutlineIcon';

/**
 * author: Google
 * id B5F74959-A897-4A3F-9E76-2154AB4B8930
 * name thumbs-up-down-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thumbs-up-down-outline.svg
 * tags
 */
export const LikeDislikeOutlineIcon = ThumbsUpDownOutlineIcon;
export default LikeDislikeOutlineIcon